import { uniq } from "lodash";
import { DataMode } from "./maping-funnel-data-source";

export type EventListDataType = { name: string; order: number };

const uniqEventLists = (eventList: string[]) => {
  return uniq(eventList);
};

const reOrder = (eventList: string[]) => {
  return eventList.map((name, index) => ({
    name,
    order: index,
  }));
};

export const reStructure = (eventList: string[]): EventListDataType[] => {
  return reOrder(uniqEventLists(eventList));
};

export const addNewEvents = (self: EventListDataType[], newEventName: string): EventListDataType[] => {
  return reStructure(self.map((s) => s.name).concat(newEventName));
};

export const removeEvents = (self: EventListDataType[], eventNameToRemove: string): EventListDataType[] => {
  return reStructure(self.map((s) => s.name).filter((name) => name !== eventNameToRemove));
};

export const reOrderEvents = (self: EventListDataType[], startIndex: number, endIndex: number): EventListDataType[] => {
  const result = Array.from(self.map((s) => s.name));
  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);

  return reStructure(result);
};

export const sortListEventNameByName = (self: EventListDataType[]) => {
  return self.sort((a, b) => a.name.localeCompare(b.name));
};

export const getListEventNameByOrder = (self: EventListDataType[]) => {
  return self.sort((a, b) => a.order - b.order);
};
const renameStepWithBetweenConversionRate = (step1: string, step2: string) => {
  return step1 + "_and_" + step2 + "_" + "conversion_rate";
};

const renameStepWithConversionRate = (step: string) => {
  return step + "_conversion_rate";
};
const renameStepWithSampleSize = (step: string) => {
  return step + "_user_count";
};

const renameStepsWithSampleSize = (step1: string, step2: string) => {
  return step1 + "_and_" + step2 + "_" + "user_count";
};

export const getStepByMode = (step: string, mode: DataMode, stepLists: string[]) => {
  const stepIndex = stepLists.findIndex((value) => value === step);
  if (stepIndex === 0) return renameStepWithConversionRate(step);
  if (mode === "compareWithUserGroup") return renameStepWithConversionRate(step);
  if (mode === "compareFirstStep") {
    return renameStepWithBetweenConversionRate(step, stepLists[0]);
  }
  return renameStepWithBetweenConversionRate(step, stepLists[stepIndex - 1]);
};

export const getStepByModeWithSampleSize = (step: string, mode: DataMode, stepLists: string[]): string[] => {
  const stepIndex = stepLists.findIndex((value) => value === step);
  if (stepIndex === 0) return [renameStepWithConversionRate(step), renameStepWithSampleSize(step)];
  if (mode === "compareWithUserGroup") return [renameStepWithConversionRate(step), renameStepWithSampleSize(step)];
  if (mode === "compareFirstStep") {
    return [renameStepWithBetweenConversionRate(step, stepLists[0]), renameStepsWithSampleSize(step, stepLists[0])];
  }
  return [
    renameStepWithBetweenConversionRate(step, stepLists[stepIndex - 1]),
    renameStepsWithSampleSize(step, stepLists[stepIndex - 1]),
  ];
};

export const convertMetricConversionRateToMetricSampleSize = (metric: string) => {
  if (!metric.endsWith("_conversion_rate")) return metric;
  return renameStepWithSampleSize(metric.replace("_conversion_rate", ""));
};
